import classnames from "classnames";
import { MouseEventHandler, ReactNode } from "react";

import { IconButton } from "@seneca/senekit";

import styles from "./Topbar.module.scss";

type Props = {
  children: ReactNode;
  warning?: boolean;
  onClose?: MouseEventHandler<Element>;
};

export default function Topbar({ children, warning, onClose }: Props) {
  return (
    <div
      className={classnames(styles.wrapper, {
        [styles.warningBackground]: warning
      })}
    >
      {children}
      {!!onClose && (
        <div className={styles.closeButton}>
          <IconButton
            iconName="cross"
            onClick={onClose}
            accessibilityLabel="Close topbar"
            blend
            size="medium"
          />
        </div>
      )}
    </div>
  );
}
